"use client";

import type { ReactNode } from "react";
import { ShopPosDesktopSimpleLayout } from "./ShopPosDesktopSimpleLayout";

export type ShopPosMainContentProps = {
  simpleMode: boolean;
  browse: ReactNode;
  cart: ReactNode;
  aside: ReactNode;
};

/** จัด layout browse | cart | scan ตามโหมด */
export function ShopPosMainContent({
  simpleMode,
  browse,
  cart,
  aside,
}: ShopPosMainContentProps) {
  if (simpleMode) {
    return (
      <ShopPosDesktopSimpleLayout
        header={null}
        browse={browse}
        cart={cart}
        aside={aside}
      />
    );
  }

  return (
    <>
      {browse}
      {cart}
    </>
  );
}
